import axios from 'axios'
import { store } from 'src/client'
import {
  PostAgentPromptRequest,
  PostAgentPromptResponse,
} from 'src/queries/agent/network/agent.models'
import {
  ExtendThreadIDHeader,
  selectAuthedJsonAgentRequestConfig,
} from 'src/redux/selectors/axios.selectors'

export const postAgentPrompt = async (
  req: PostAgentPromptRequest,
): Promise<PostAgentPromptResponse> => {
  const state = store.getState()
  const requestConfig = selectAuthedJsonAgentRequestConfig(state)

  const { threadId, ...reqRest } = req
  requestConfig.headers = {
    ...requestConfig.headers,
    [ExtendThreadIDHeader]: threadId ?? '',
  }

  const response = await axios.post<PostAgentPromptResponse>(
    '/prompt',
    reqRest,
    requestConfig,
  )

  const responseThreadId = (response?.headers?.[
    ExtendThreadIDHeader.toLowerCase()
  ] ?? req.threadId) as string
  if (responseThreadId === undefined)
    throw new Error(
      'postPromptAgentStream: no thread_id returned from response',
    )

  return {
    ...response.data,
    threadId: responseThreadId,
  }
}

export function assertNever(value: never, tag?: string): never {
  throw new Error(`assertNever ${tag ?? ''} - Unexpected value: ${value}`)
}
